export default "__VITE_ASSET__98f60480__"